module.exports = __webpack_public_path__ + "static/img/48120.0531932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48120.jpg
// module id = Rh4T
// module chunks = 1